var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#74b3f5",
    d: "m19,2H5C2.243,2,0,4.243,0,7v10c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V7c0-2.757-2.243-5-5-5Zm3,15c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V7c0-1.654,1.346-3,3-3h14c1.654,0,3,1.346,3,3v10Zm-11,0c0,.553-.448,1-1,1h-5c-.552,0-1-.447-1-1s.448-1,1-1h5c.552,0,1,.447,1,1Zm9,0c0,.553-.447,1-1,1h-5c-.553,0-1-.447-1-1s.447-1,1-1h5c.553,0,1,.447,1,1ZM4,9v-2c0-.552.448-1,1-1h9c.552,0,1,.448,1,1v2c0,.552-.448,1-1,1H5c-.552,0-1-.448-1-1Zm0,4c0-.553.448-1,1-1h1c.552,0,1,.447,1,1s-.448,1-1,1h-1c-.552,0-1-.447-1-1Zm7,0c0,.553-.448,1-1,1h-1c-.552,0-1-.447-1-1s.448-1,1-1h1c.552,0,1,.447,1,1Zm2,1c-.552,0-1-.447-1-1s.448-1,1-1h1c.553,0,1,.447,1,1s-.447,1-1,1h-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileName);
export default __webpack_public_path__ + "static/media/profileName.5945b291bef8ed71076ec8a1e49ffdf6.svg";
export { ForwardRef as ReactComponent };